
import * as React from "react"

export const MOBILE_BREAKPOINT = 768
export const TABLET_BREAKPOINT = 1024

const getInitialMobileState = () => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    return window.innerWidth < MOBILE_BREAKPOINT
  }
  // Default to false for SSR
  return false
}

const getInitialTabletState = () => {
  if (typeof window !== 'undefined') {
    const width = window.innerWidth
    return width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT
  }
  return false
}

const getInitialMobileOrTabletState = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < TABLET_BREAKPOINT
  }
  return false
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(getInitialMobileState)

  React.useEffect(() => {
    // Sync immediately on mount in case viewport changed during hydration
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return isMobile
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = React.useState<boolean>(getInitialTabletState)

  React.useEffect(() => {
    // Sync immediately on mount
    const width = window.innerWidth
    setIsTablet(width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT)
    
    const handleResize = () => {
      const w = window.innerWidth
      setIsTablet(w >= MOBILE_BREAKPOINT && w < TABLET_BREAKPOINT)
    }
    
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return isTablet
}

export function useIsMobileOrTablet() {
  const [isMobileOrTablet, setIsMobileOrTablet] = React.useState<boolean>(getInitialMobileOrTabletState)

  React.useEffect(() => {
    // Sync immediately on mount
    setIsMobileOrTablet(window.innerWidth < TABLET_BREAKPOINT)
    
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < TABLET_BREAKPOINT)
    }
    
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return isMobileOrTablet
}
